import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import "./DetailJobView.scss";

import axios from "axios";

import { useParams, useNavigate } from "react-router-dom";

import validator from "validator";

import {
  useToast,
  FormControl,
  FormLabel,
  Input,
  FormErrorMessage,
  FormHelperText,
  Spinner,
  Button,
  Textarea,
} from "@chakra-ui/react";
import {
  ChevronLeftIcon,
  ChevronDownIcon,
  ChevronUpIcon,
  EmailIcon,
} from "@chakra-ui/icons";

import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/high-res.css";

import emailjs from "@emailjs/browser";

import moment from "moment";

import parse from "html-react-parser";

import { updateUserFromViewJob } from "../../state/action-creators";

const PRIVACY_INFO_TEXT =
  "Workoza uses this provided information to apply you to job. You may unsubscribe from these communications at any time.";

const PLACEHOLDER_TEXT = {
  NAME: "Enter your name",
  PHONE_NUMBER: "Enter your phone number",
  EMAIL: "Enter your email",
  LINK: "Enter your uploaded resume link",
};

const ERROR_TEXT = {
  NAME: "name is required.",
  PHONE_NUMBER: "phone number is not valid.",
  EMAIL: "email is not valid.",
  LINK: "link is not valid.",
};

const RESUME_LINK_INPUT_HELPER = "Make sure uploaded resume is visible.";

const defaultStyles = {
  containerStyle: {
    width: "100%",
  },
  inputStyle: {
    width: "100%",
    height: "40px",
    backgroundColor: "inherit",
    fontSize: "1rem",
    color: "#717171",
    border: "2px solid #edf0f0",
    borderRadius: "8px",
  },
  buttonStyle: {
    borderTop: "2px solid #edf0f0",
    borderBottom: "2px solid #edf0f0",
    borderRadius: 0,
    borderRight: "none",
    borderLeft: "none",
    marginLeft: "8px",
    width: "48px",
    backgroundColor: "#ffffff",
  },
  focusStyle: {
    border: "2px solid #2b6cb1",
  },
  buttonFocusStyle: {
    borderTop: "2px solid #2b6cb1",
    borderBottom: "2px solid #2b6cb1",
  },
  errorStyle: {
    border: "2px solid #e43e3f",
  },
  buttonErrorStyle: {
    borderTop: "2px solid #e43e3f",
    borderBottom: "2px solid #e43e3f",
  },
};

const DetailJobView = (props) => {
  const { updateUserFromViewJob, isApplyNow } = props;

  const navigate = useNavigate();

  const { jobId } = useParams();

  const [selectedJob, setSelectedJob] = useState({});
  const [isViewMoreDetailsClick, setIsViewMoreDetailsClick] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  // form local state
  const [name, setName] = useState("");
  const [isNameNotValid, setIsNameNotValid] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState({});
  const [isPhoneNumberFocused, setIsPhoneNumberFocused] = useState(false);
  const [isPhoneNumberNotValid, setIsPhoneNumberNotValid] = useState(false);
  const [email, setEmail] = useState("");
  const [isEmailNotValid, setIsEmailNotValid] = useState(true);
  const [resumeLink, setResumeLink] = useState("");
  const [isResumeLinkNotValid, setIsResumeLinkNotValid] = useState(false);
  const [doubt, setDoubt] = useState("");

  const toast = useToast();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    if (!isApplyNow) {
      setIsViewMoreDetailsClick(true);
    }
  }, [isApplyNow]);

  useEffect(() => {
    updateUserFromViewJob(true);
  }, [updateUserFromViewJob]);

  useEffect(() => {
    const fetchJob = async () => {
      try {
        setIsLoading(true);
        const res = await axios.get(
          `https://workoza-server-vercel.vercel.app/api/job/${jobId}`
        );
        setSelectedJob(res?.data);
      } catch (e) {
        console.log(e);
      } finally {
        setIsLoading(false);
      }
    };

    fetchJob();
  }, [jobId]);

  const renderGoBackButton = () => {
    const handleViewJobGoBackClick = () => {
      navigate(-1);
    };

    return (
      <div className="viewJobButtonContainer">
        <Button
          leftIcon={<ChevronLeftIcon w={6} h={6} />}
          size="md"
          variant="link"
          onClick={handleViewJobGoBackClick}
        >
          Go back
        </Button>
      </div>
    );
  };

  const renderViewJobFeed = () => {
    const {
      title,
      jobType,
      position,
      startDate,
      endDate,
      jobId,
      jobStatus,
      location,
      createdAt,
      description,
      responsibility,
      skill,
    } = selectedJob || {};

    const renderViewJobFeedTopFeed = () => {
      return (
        <div className="viewJobFeedTopContainer">
          <div className="viewJobTitleContainer">{title}</div>
          <div className="viewJobDetailsContainer">
            <div className="viewJobDetailsWrapContainer">
              <div className="viewJobDetailsEachContainer">
                <div className="viewJobDetailsEachTypeContainer">
                  Job Type:{" "}
                  <span className={"viewJobDetailsEachTypeBoldText"}>
                    {jobType}
                  </span>
                </div>
                <div className="viewJobDetailsEachTypeContainer">
                  Positions to fill:{" "}
                  <span className={"viewJobDetailsEachTypeBoldText"}>
                    {position}
                  </span>
                </div>
              </div>
              <div className="viewJobDetailsEachContainer">
                <div className="viewJobDetailsEachTypeContainer">
                  Job Start Date:{" "}
                  <span className={"viewJobDetailsEachTypeBoldText"}>
                    {startDate}
                  </span>
                </div>
                <div className="viewJobDetailsEachTypeContainer">
                  Job End Date:{" "}
                  <span className={"viewJobDetailsEachTypeBoldText"}>
                    {endDate}
                  </span>
                </div>
              </div>
            </div>
            <div className="viewJobDetailsWrapContainer">
              <div className="viewJobDetailsEachContainer">
                <div className="viewJobDetailsEachTypeContainer">
                  Job ID:{" "}
                  <span className={"viewJobDetailsEachTypeBoldText"}>
                    {jobId}
                  </span>
                </div>
                <div className="viewJobDetailsEachTypeContainer">
                  Job Status:{" "}
                  <span className={"viewJobDetailsEachTypeBoldText"}>
                    {jobStatus}
                  </span>
                </div>
              </div>
              <div className="viewJobDetailsEachContainer">
                <div className="viewJobDetailsEachTypeContainer">
                  Location:{" "}
                  <span className={"viewJobDetailsEachTypeBoldText"}>
                    {location}
                  </span>
                </div>
                <div className="viewJobDetailsEachTypeContainer">
                  Posted on:{" "}
                  <span className={"viewJobDetailsEachTypeBoldText"}>
                    {moment(createdAt).format("DD MMM, YYYY")}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    };

    const renderViewMoreJobDetails = () => {
      const handleViewMoreJobDetailsClick = () => {
        setIsViewMoreDetailsClick(!isViewMoreDetailsClick);
      };

      const buttonRightIcon = isViewMoreDetailsClick ? (
        <ChevronUpIcon w={6} h={6} />
      ) : (
        <ChevronDownIcon w={6} h={6} />
      );

      return (
        <div className="viewMoreJobDetailsContainer">
          <Button
            rightIcon={buttonRightIcon}
            size="md"
            variant="ghost"
            _hover={{ background: "#dbdbdb", color: "#484848" }}
            onClick={handleViewMoreJobDetailsClick}
          >
            View more job details
          </Button>
        </div>
      );
    };

    const renderViewJobFeedBottomFeed = () => {
      return (
        <div className="viewJobFeedBottomContainer">
          {description ? (
            <div className="viewJobDescriptionContainer">
              <div className="viewJobBottomContainerTitleText">
                Description:
              </div>
              <div className="viewJobBottomContainerSubText">{description}</div>
            </div>
          ) : null}
          <div className="viewJobDescriptionContainer">
            <div className="viewJobBottomContainerTitleText">
              Responsibilities:
            </div>
            <div className="viewJobBottomContainerSubText">
              {parse(String(responsibility))}
            </div>
          </div>
          <div className="viewJobDescriptionContainer">
            <div className="viewJobBottomContainerTitleText">Must Have:</div>
            <div className="viewJobBottomContainerSubText">
              {parse(String(skill))}
            </div>
          </div>
        </div>
      );
    };

    // form container same as contact us
    const renderApplyNowFormFeed = () => {
      const renderApplyNowForm = () => {
        const handleNameChange = (e) => {
          setName(e?.target?.value);
        };
        const handlePhoneNumberChange = (phone, other) => {
          setPhoneNumber({
            phone,
            other,
          });
        };
        const handleEmailChange = (e) => {
          setEmail(e?.target?.value);
        };
        const handleResumeLinkChange = (e) => {
          setResumeLink(e?.target?.value);
        };
        const handleDoubtChange = (e) => {
          setDoubt(e?.target?.value);
        };

        const handleSubmitDetails = async () => {
          const checkIsNameNotValid = name?.length <= 0;
          const checkPhoneNumberNotValid =
            phoneNumber?.other?.name === "India"
              ? phoneNumber?.phone?.length !== 12
              : phoneNumber?.phone?.length !== 11;
          const checkEmailNotValid = String(email)
            .toLowerCase()
            .match(
              /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            );
          const checkResumeLinkNotValid = !validator.isURL(resumeLink);

          setIsNameNotValid(checkIsNameNotValid);
          setIsPhoneNumberNotValid(checkPhoneNumberNotValid);
          setIsEmailNotValid(checkEmailNotValid);
          setIsResumeLinkNotValid(checkResumeLinkNotValid);

          if (
            selectedJob &&
            !checkIsNameNotValid &&
            !checkPhoneNumberNotValid &&
            checkEmailNotValid &&
            !checkResumeLinkNotValid
          ) {
            const formattedPhoneNumber =
              String(phoneNumber?.other?.name) +
              " " +
              `+${phoneNumber?.other?.dialCode}` +
              " " +
              String(phoneNumber?.phone);
            const formData = {
              email,
              jobID: jobId,
              name,
              phoneNumber: formattedPhoneNumber,
              resumeLink,
              doubt: doubt ? doubt : "No doubt",
              jobTitle: title,
              jobType,
              jobLocation: location,
              jobPosition: position,
              jobStartDate: startDate,
              jobEndDate: endDate,
            };
            console.log("1000- formData", formData);
            await emailjs
              .send(
                process.env.REACT_APP_EMAIL_SERVICE_ID,
                process.env.REACT_APP_EMAIL_JOB_APPLICATION_TEMPLATE_ID,
                formData,
                process.env.REACT_APP_EMAIL_PUBLIC_KEY
              )
              .then(
                (result) => {
                  console.log("Email sent successfully...🚀");
                  setName("");
                  setIsNameNotValid(false);
                  setPhoneNumber({});
                  setIsPhoneNumberNotValid(false);
                  setIsPhoneNumberFocused(false);
                  setEmail("");
                  setIsEmailNotValid(true);
                  setResumeLink("");
                  setIsResumeLinkNotValid(false);
                  setDoubt("");
                },
                (error) => {
                  console.log("Something went wrong!!!");
                }
              );
            toast({
              title: `Successfully applied for job ${jobId}`,
              status: "success",
              position: "bottom-left",
              duration: 5000,
              isClosable: true,
            });
          }
        };

        const mergedErrInputStyle = {
          ...defaultStyles.inputStyle,
          ...defaultStyles.errorStyle,
        };
        const mergedFocusInputStyle = {
          ...defaultStyles.inputStyle,
          ...defaultStyles.focusStyle,
        };

        const mergedErrButtonStyle = {
          ...defaultStyles.buttonStyle,
          ...defaultStyles.buttonErrorStyle,
        };
        const mergedFocusButtonStyle = {
          ...defaultStyles.buttonStyle,
          ...defaultStyles.buttonFocusStyle,
        };

        const handleFocus = () => {
          setIsPhoneNumberFocused(true);
        };

        const handleBlur = () => {
          setIsPhoneNumberFocused(false);
        };

        const phoneNumberDigits = phoneNumber?.phone;

        return (
          <div className="viewJobApplyNowFormWrapperFeed">
            <div className="contactUsNameContainer">
              <FormControl isRequired isInvalid={isNameNotValid}>
                <FormLabel>Name</FormLabel>
                <Input
                  type="email"
                  placeholder={PLACEHOLDER_TEXT.NAME}
                  value={name}
                  onChange={handleNameChange}
                />
                <FormErrorMessage>{ERROR_TEXT.NAME}</FormErrorMessage>
              </FormControl>
            </div>
            <div className="contactusPhoneEmailContainer">
              <div className="contactUsPhoneContainer">
                <FormControl isRequired isInvalid={isPhoneNumberNotValid}>
                  <FormLabel>Phone number</FormLabel>
                  <PhoneInput
                    country={"in"}
                    placeholder={PLACEHOLDER_TEXT.PHONE_NUMBER}
                    onlyCountries={["in", "ca", "us"]}
                    onFocus={handleFocus}
                    onBlur={handleBlur}
                    inputStyle={
                      isPhoneNumberNotValid
                        ? mergedErrInputStyle
                        : isPhoneNumberFocused
                        ? mergedFocusInputStyle
                        : defaultStyles.inputStyle
                    }
                    buttonStyle={
                      isPhoneNumberNotValid
                        ? mergedErrButtonStyle
                        : isPhoneNumberFocused
                        ? mergedFocusButtonStyle
                        : defaultStyles.buttonStyle
                    }
                    containerClass={defaultStyles.containerStyle}
                    value={phoneNumberDigits ? phoneNumberDigits : ""}
                    onChange={handlePhoneNumberChange}
                  />
                  <FormErrorMessage>{ERROR_TEXT.PHONE_NUMBER}</FormErrorMessage>
                </FormControl>
              </div>
              <div className="contactUsEmailContainer">
                <FormControl isRequired isInvalid={!isEmailNotValid}>
                  <FormLabel>Email</FormLabel>
                  <Input
                    type="text"
                    placeholder={PLACEHOLDER_TEXT.EMAIL}
                    value={email}
                    onChange={handleEmailChange}
                  />
                  <FormErrorMessage>{ERROR_TEXT.EMAIL}</FormErrorMessage>
                </FormControl>
              </div>
            </div>
            <div className="contactUsNameContainer">
              <FormControl isRequired isInvalid={isResumeLinkNotValid}>
                <FormLabel>Uploaded Resume Link</FormLabel>
                <Input
                  type="text"
                  placeholder={PLACEHOLDER_TEXT.LINK}
                  value={resumeLink}
                  onChange={handleResumeLinkChange}
                />
                <FormErrorMessage>{ERROR_TEXT.LINK}</FormErrorMessage>
                <FormHelperText>{RESUME_LINK_INPUT_HELPER}</FormHelperText>
              </FormControl>
            </div>
            <div className="contactusInquiryContainer">
              <FormControl>
                <FormLabel>Any Doubt ?</FormLabel>
                <Textarea
                  value={doubt}
                  onChange={handleDoubtChange}
                  size="sm"
                  resize={"none"}
                />
              </FormControl>
            </div>
            <div className="contactusPrivacyInfo">{PRIVACY_INFO_TEXT}</div>
            <div className="contactusSubmitButtonContainer">
              <Button
                rightIcon={<EmailIcon />}
                size="md"
                variant="solid"
                color="#ffffff"
                background="#d33853"
                _hover={{ background: "#af273e", color: "#f9f9f9" }}
                onClick={handleSubmitDetails}
              >
                Apply
              </Button>
            </div>
          </div>
        );
      };

      return (
        <div className="viewJobApplyNowFormContainer">
          <div className="viewJobApplyNowFormWrapper">
            <div className="viewJobApplyNowContactusText">Apply Now</div>
            <div className="viewJobApplyNowContactusSubText">
              Please fill below form to apply for this job.
            </div>
            {renderApplyNowForm()}
          </div>
          <div className="viewJobApplyNowFeedImgContainer">
            <img
              src="/contactus_banner.jpeg"
              alt="no banner"
              className="viewJobApplyNowBannerImage"
            />
          </div>
        </div>
      );
    };

    return (
      <div className="viewJobFeedContainer">
        {renderViewJobFeedTopFeed()}
        {isApplyNow && renderViewMoreJobDetails()}
        {isViewMoreDetailsClick && renderViewJobFeedBottomFeed()}
        {isApplyNow && renderApplyNowFormFeed()}
      </div>
    );
  };

  return (
    <div className="viewJobContainer">
      <div className="viewJobWrapper">
        {renderGoBackButton()}
        {isLoading ? (
          <div className="viewJobLoadingContainer">
            <Spinner
              thickness="4px"
              speed="0.65s"
              emptyColor="#717171"
              color="#d33853"
              size="lg"
            />
          </div>
        ) : (
          renderViewJobFeed()
        )}
      </div>
    </div>
  );
};

const mapActionCreators = {
  updateUserFromViewJob,
};

export default connect(null, mapActionCreators)(DetailJobView);
